import { CSSProperties, FC, useMemo } from 'react';
import cls from 'classnames';
import { pxToRem } from '~/utils/px-to-rem';
import { IUserAuthInfo } from 'shared/models/user-auth-info';

import './index.rem.scss';

interface UserAuthIconProps {
  authInfo: IUserAuthInfo;
  width?: number | string | undefined;
  height?: number | string | undefined;
  marginLeft?: number | string | undefined;
  /** 用户认证icon显示为白色，视频详情页icon颜色为白色 */
  light?: boolean;
}

const DEFAULT_WIDTH = pxToRem(20);
const DEFAULT_HEIGHT = pxToRem(20);
const DEFAULT_MARGIN_LEFT = pxToRem(4);

export const UserAuthIcon: FC<UserAuthIconProps> = (props) => {
  const {
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    marginLeft = DEFAULT_MARGIN_LEFT,
    light = false,
    authInfo,
  } = props;

  const style: CSSProperties = useMemo(
    () => ({
      width: typeof width === 'number' ? pxToRem(width) : width,
      height: typeof height === 'number' ? pxToRem(height) : height,
      marginLeft: typeof marginLeft === 'number' ? pxToRem(marginLeft) : marginLeft,
    }),
    [width, height, marginLeft],
  );

  if (!authInfo.showAuthSymbol) {
    return null;
  }

  return (
    <div
      className={cls('user-auth-icon', {
        light,
      })}
      style={style}
    />
  );
};
